import { DATES } from 'app/_constants/dates.constant';
import { CreditLimitResource } from 'app/_resources/credit-limit.resource';
import { CreditFrameworkResource } from 'app/_resources/credit-framework.resource';
import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { AuthService } from '../_services/auth.service';
import { config, reactShell } from '../../angular/utils/config';

type EditingMode = 'create' | 'edit' | 'read';

class shippersDetailsCreditLimitComponentCtrl implements ng.IController {
    public creditLimit: CreditLimitDto;
    public editedCreditLimit: any = {};
    public selectableCreditFrameworks: CreditFrameworkDto;

    public mode: EditingMode;

    public onCreditLimitSaved: Function;
    public onCreditLimitDeleted: Function;
    public onError: Function;
    public minRuntimeStart: Date;
    public isStorage: boolean;
    public conmaSubscription = false;

    constructor(
        private DATES: DATES,
        private creditLimitResource: CreditLimitResource,
        private creditFrameworkResource: CreditFrameworkResource,
        private authService: AuthService
    ) {
        this.minRuntimeStart = new Date();
    }

    async $onInit() {
        if (this.mode === 'create') {
            this.editedCreditLimit = this.creditLimit;
            this.creditFrameworkResource.getCreditFrameworksForLoggedInTso(
                (data) => {
                    this.selectableCreditFrameworks = data;
                }
            );
        }

        if (config.contractManagement) {
            try {
                const response = await reactShell.axios.request({
                    url: config.contractManagement
                });
                this.conmaSubscription = Boolean(
                    response.data &&
                        response.data._links &&
                        response.data._links.shipper
                );
            } catch (err) {
                // just swallow any error - as of now this is only relevant to TAG and they _know_
                // they should not delete credit limits (we don't want to confuse other users in case of an error)
            }
        }

        this.authService.userLoginPromise.promise.then(
            (res) => (this.isStorage = res.role === 'SSO_ADMIN')
        );
    }

    public startEditingCreditLimit() {
        this.mode = 'edit';
        this.editedCreditLimit = angular.copy(this.creditLimit);
    }

    public stopEditingCreditLimit() {
        this.mode = 'read';
        this.editedCreditLimit = {};
    }

    public stopCreatingCreditLimit() {
        this.mode = 'read';
        this.creditLimit = null;
    }

    public deleteCreditLimit() {
        this.creditLimitResource.deleteCreditLimit(
            { id: this.creditLimit.id },
            () => {
                this.onCreditLimitDeleted({
                    deletedCreditLimit: this.creditLimit
                });
            },
            () => {
                this.onError({
                    message: 'An error occured while deleting the credit limit.'
                });
            }
        );
    }

    public saveCreditLimit() {
        this.creditLimitResource.updateCreditLimit(
            this.editedCreditLimit,
            (savedCreditLimit: CreditLimitDto) => {
                this.onCreditLimitSaved({
                    savedCreditLimit,
                    isNew: this.mode === 'create'
                });
                this.creditLimit = savedCreditLimit;
                this.mode = 'read';
            },
            (err: any) => {
                const message =
                    err && err.data && err.data.description
                        ? err.data.description
                        : 'An unknown error occurred. Please, check back later.';
                this.onError({ message });
            }
        );
    }

    get limitAlmostExhaustet(): boolean {
        if (!this.creditLimit) return;
        return (
            (this.creditLimit.staticLimit.amount.value as Decimal).gt(0) &&
            (this.creditLimit.usedLimit.amount.value as Decimal)
                .div(this.creditLimit.staticLimit.amount.value)
                .gte('0.8')
        );
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }
        this.saveCreditLimit();
        return true;
    }
}

angular.module('app').component('pkpShippersDetailsCreditLimit', {
    controller: shippersDetailsCreditLimitComponentCtrl,
    template: require('app/shippers/shippers-details-credit-limit.component.html'),
    bindings: {
        mode: '@',
        creditLimit: '=',
        onCreditLimitSaved: '&',
        onCreditLimitDeleted: '&',
        onError: '&'
    }
});
